<div mat-dialog-title class="relative flex flex-row items-center justify-between border-b border-gray-200 px-6 py-3 mb-0">
  <h2 class="flex-1 m-0 text-2xl font-bold">{{ 'contextualModal.additionalInstructions.title' | translate }}</h2>
  <flow-button class="absolute right-4 top-2.5" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="px-8 py-6 max-h-[75vh] overflow-y-auto">
  <ng-container *ngIf="state$ | async as state">
    <div *ngIf="state.loading" class="flex justify-center py-10">
      <flow-spinner></flow-spinner>
    </div>

    <div
      *ngIf="!state.loading && state.content"
      class="manual-content"
      (click)="onContentClick($event)"
      [innerHTML]="state.content"></div>

    <p *ngIf="!state.loading && !state.content" class="m-0 text-sm text-gray-700">
      {{ 'contextualModal.additionalInstructions.empty' | translate }}
    </p>
  </ng-container>
</mat-dialog-content>
